var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 20,
    r: 20,
    fill: "#415385"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5031 14.576H15.6311L20.0311 26H17.8871L16.8151 22.976H12.2551L11.1831 26H9.11913L13.5031 14.576ZM12.7991 21.456H16.2871L14.5751 16.544H14.5271L12.7991 21.456ZM22.719 19.36H25.983C26.463 19.36 26.863 19.2267 27.183 18.96C27.503 18.6827 27.663 18.288 27.663 17.776C27.663 17.2 27.519 16.7947 27.231 16.56C26.943 16.3253 26.527 16.208 25.983 16.208H22.719V19.36ZM20.719 14.576H26.271C27.295 14.576 28.1163 14.8107 28.735 15.28C29.3537 15.7493 29.663 16.4587 29.663 17.408C29.663 17.984 29.519 18.48 29.231 18.896C28.9537 19.3013 28.5537 19.616 28.031 19.84V19.872C28.735 20.0213 29.2683 20.3573 29.631 20.88C29.9937 21.392 30.175 22.0373 30.175 22.816C30.175 23.264 30.095 23.6853 29.935 24.08C29.775 24.464 29.5243 24.8 29.183 25.088C28.8417 25.3653 28.4043 25.5893 27.871 25.76C27.3377 25.92 26.703 26 25.967 26H20.719V14.576ZM22.719 24.368H26.255C26.863 24.368 27.3323 24.2133 27.663 23.904C28.0043 23.584 28.175 23.136 28.175 22.56C28.175 21.9947 28.0043 21.5627 27.663 21.264C27.3323 20.9547 26.863 20.8 26.255 20.8H22.719V24.368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAb);
export default __webpack_public_path__ + "static/media/profile-AB.81be1604f4607dcc9f6ac87389b9fc1a.svg";
export { ForwardRef as ReactComponent };